/* @flow weak */

'use strict';

const React = require('react');
const _ = require('lodash');
const ControlMixin = require('../../mixins/ControlMixin.jsx');

const Config = require('../../configs/Config.js');

const ImageSelect = React.createClass({
  mixins: [ControlMixin],

  render() {
    let controls = _.map(this.props.parts, part => {
      let inputID = `uc-c-${this.props.question.id}-${part.id}`;
      let activeClass = this.state.answer === part.id ? ' uc-active uc-checkmark' : '';
      let classremoveHyphen = _.get(part, 'metadata.RemoveHyphen')? ' uc-part-without-hyphen' : '';
      const hidePartNameClass = this.isPartNamesHidden(this.props.question) ? ' uc-hide-part-name' : '';
      
      let s3url = Config.images.s3url;

      const partDetails = this.getPartDetails(part);

      return (
        <label
          className={'uc-image-select-label' + activeClass}
          key={part.id}
          role='radio' 
          htmlFor={inputID}>
          <input
            id={inputID}
            className='uc-c uc-image-select-input'
            type='radio'
            name={this.props.question.name}
            onChange={this.handleChange}
            checked={this.state.answer === part.id}
            value={part.id}
            tabIndex={this.props.tabIndex}
            disabled={this.state.locked} />
          
          <img alt={this.displayPartName(part)} src={s3url + _.get(part, 'metadata.StaticImage')} />

          <div className={'uc-part-name' + classremoveHyphen + hidePartNameClass}>
            <p>{this.displayPartTitle(part)}</p>
            <p>{this.displayPartName(part)}</p>
            <p>{this.displayPrice(part)}</p>
          </div>
          {partDetails ?
            <p className="uc-part-details" dangerouslySetInnerHTML={{__html: partDetails}}></p>
            : null}
        </label>
      );
    });

    return (
      <div className='uc-control uc-image-select'>
        {controls}
      </div>
    );
  }
});

module.exports = ImageSelect;


// WEBPACK FOOTER //
// ./src/base/scripts/components/controls/ImageSelect.jsx